import ActionFieldsMixin from './action-fields-mixin'
import BotProtectedSubmitButton from '@/components/buttons/bot-protected-submit-button'
import camelCase from 'lodash/camelCase'
import HasAdditionalFields from '@/mixins/has-additional-fields'
import { mapGetters, mapMutations, mapState } from 'vuex'

export default {
  components: { BotProtectedSubmitButton },

  mixins: [ ActionFieldsMixin, HasAdditionalFields ],

  computed: {
    ...mapGetters(['oneClickSigning', 'shouldShowDataProcessingConsent', 'suppressEmailOptInField']),
    ...mapState(['action', 'createActionUrl', 'fields', 'submittingCreateAction', 'validationErrors']),

    fieldsToInclude() {
      return this.fields.filter((fieldConfig) => {
        if (this.suppressEmailOptInField && fieldConfig.name === 'joinOrganisation') {
          return false
        } else if (this.oneClickSigning) {
          // Skip field if it's suppressed from one-click signing, or if it can be implicitly set from
          // CRM, and that's how it got its value
          return !(fieldConfig.suppressForOneClick ||
                   (fieldConfig.hideIfSetFromCrm && this.$store.getters.fieldWasSetFromCrm(fieldConfig.name)))
        } else {
          return true
        }
      })
    }
  },

  methods: {
    ...mapMutations(['setAdditionalFieldValue', 'setEmailOptInValues', 'setFieldValue', 'setSmsOptInValues']),

    fieldValue(fieldName) {
      return this.$store.getters.fieldValue(fieldName)
    },

    shouldShowField(fieldConfig) {
      if (fieldConfig.isAdditionalField) {
        return this.shouldShowAdditionalField(fieldConfig)
      } else if (fieldConfig.name === 'euDataProcessingConsent') {
        return this.shouldShowDataProcessingConsent
      } else {
        return true
      }
    },

    validationErrorsForField(fieldName) {
      return this.validationErrors[camelCase(fieldName)]
    }
  }
}
